import {
  Container,
  Paper,
  Typography,
  Grid2,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  SelectChangeEvent,
} from "@mui/material";
import { useEffect, useState } from "react";
import { TrainingSchedule } from "../../model/entity/TrainingSchedule";
import { notifErr } from "../../components/Functions";
import handleAxiosError from "../../components/ErrorHandler";
import { Loading } from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { getFetcher, putFetcher } from "../../components/Fetchers";

const ScheduleSettings = () => {
  const navigate = useNavigate();
  const [selectedSchedule, setSelectedSchedule] =
    useState<TrainingSchedule | null>(null);
  const [schedules, setSchedules] = useState<TrainingSchedule[] | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getFetcher(
          `${process.env.REACT_APP_API_URL}/schedules`
        );
        const schedules: TrainingSchedule[] = response.data;
        setSchedules(schedules);

        if (schedules.length > 0)
          setSelectedSchedule(schedules.find((s) => s.active)!);
      } catch (err) {
        notifErr(handleAxiosError(err));
      }
    };

    fetchData();
  }, []);

  const handleSelectedScheduleChange = async (e: SelectChangeEvent) => {
    if (!schedules) return;
    const parsedVal = parseInt(e.target.value);
    const newSelectedSchedule = schedules.find((s) => s.id === parsedVal);
    if (!newSelectedSchedule) {
      notifErr("Nastala neočekávaná chyba.");
      return;
    }
    if (newSelectedSchedule.id === selectedSchedule?.id) return;

    try {
      const response = await putFetcher(
        `${process.env.REACT_APP_API_URL}/schedules/change-active-schedule`,
        newSelectedSchedule
      );
      setSelectedSchedule(response.data);
      window.location.reload();
    } catch (err) {
      notifErr(handleAxiosError(err));
    }
  };

  if (
    schedules === null ||
    (schedules && schedules.length > 0 && selectedSchedule === null)
  )
    return <Loading />;
  else if (selectedSchedule === null) {
    return (
      <Container
        maxWidth="md"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pb: "2rem",
        }}
      >
        <Paper elevation={3} sx={{ padding: "1.5rem" }}>
          <Grid2 sx={{ display: "flex", justifyContent: "center" }}>
            <Typography variant="h5" sx={{ marginBottom: "1.5rem" }}>
              <b>Žádný dostupný rozvrh</b>
            </Typography>
          </Grid2>

          <Grid2 sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              className="successBtnFilled"
              onClick={() => navigate("/schedule/settings/add-new")}
            >
              Vytvořit rozvrh
            </Button>
          </Grid2>
        </Paper>
      </Container>
    );
  } else
    return (
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pb: "2rem",
        }}
      >
        <Paper elevation={3} sx={{ padding: "1.5rem" }}>
          <Grid2
            container
            spacing={3}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Typography variant="h5">Správa rozvrhů</Typography>
            <Grid2
              size={{ xs: 12 }}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <FormControl size="small" sx={{ width: "50%" }}>
                <InputLabel>Aktuální rozvrh</InputLabel>
                <Select
                  label="Aktuální rozvrh"
                  value={selectedSchedule.id!.toString()}
                  onChange={handleSelectedScheduleChange}
                >
                  {schedules.map((schedule) => (
                    <MenuItem key={schedule.id!} value={schedule.id!}>
                      {schedule.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid2>

            <Grid2
              size={{ xs: 12 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography variant="body1">
                Datum zahájení:{" "}
                <b>{dayjs(selectedSchedule.startDate).format("DD.MM.YYYY")}</b>
              </Typography>

              <Typography variant="body1">
                Datum ukončení:{" "}
                <b>{dayjs(selectedSchedule.endDate).format("DD.MM.YYYY")}</b>
              </Typography>
            </Grid2>
            <Grid2
              size={{ xs: 12 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 1.5,
                mt: 1,
              }}
            >
              <Button
                variant="outlined"
                className="cancelBtn"
                onClick={() => navigate(-1)}
              >
                Zpět
              </Button>
              <Button
                variant="outlined"
                className="editBtn"
                onClick={() => navigate("/schedule/settings/create-copy")}
              >
                Vytvořit kopii
              </Button>
              <Button
                variant="outlined"
                className="editBtn"
                onClick={() =>
                  navigate(`/schedule/settings/edit/${selectedSchedule.id}`)
                }
              >
                Upravit
              </Button>
              <Button
                className="successBtn"
                variant="outlined"
                onClick={() => navigate("/schedule/settings/add-new")}
              >
                Vytvořit
              </Button>
            </Grid2>
          </Grid2>
        </Paper>
      </Container>
    );
};

export default ScheduleSettings;
